import { defaultPageSize } from './config'

export function toggleFilterItem(value, filterState) {
  const clone = { ...filterState }
  if (clone[value]) {
    delete clone[value]
    return clone
  }

  return { ...clone, [value]: true }
}

export function queryArrayToKeys(query) {
  if (!Array.isArray(query)) return { [query]: true }
  return query.reduce((acc, key) => ({ ...acc, [key]: true }), {})
}

export function generateRouterQuery(state) {
  return {
    priceStart: state.price.start,
    priceEnd: state.price.end,
    leaseFinanceStart: state.leaseFinance.start,
    leaseFinanceEnd: state.leaseFinance.end,
    yearStart: state.year.start,
    yearEnd: state.year.end,
    mileageStart: state.mileage.start,
    mileageEnd: state.mileage.end,
    viewType: state.viewType,
    distance: state.distance,
    zipCode: state.location.zipCode,
    latitude: state.location.latitude,
    longitude: state.location.longitude,
    authRedirect: state.authRedirect,
    membership: state.membership,
    ...(Object.keys(state.listingType).length
      ? { listingType: Object.keys(state.listingType) }
      : {}),
    ...(state.searchTerms != null ? { searchTerms: state.searchTerms } : {}),
    ...(Object.keys(state.makes).length ? { makes: JSON.stringify(state.makes) } : {}),
    ...(Object.keys(state.models).length ? { models: JSON.stringify(state.models) } : {}),
    ...(Object.keys(state.sortType).length ? { sortOrder: state.sortType.sortOrder } : ''),
    ...(Object.keys(state.sortType).length ? { fieldName: state.sortType.fieldName } : ''),
    ...(Object.keys(state.bodyStyle).length ? { bodyStyle: Object.keys(state.bodyStyle) } : {}),
    ...(Object.keys(state.feature).length ? { feature: Object.keys(state.feature) } : {}),
    ...(Object.keys(state.fuel).length ? { fuel: Object.keys(state.fuel) } : {}),
    ...(Object.keys(state.engineSize).length ? { engineSize: Object.keys(state.engineSize) } : {}),
    ...(Object.keys(state.transmission).length
      ? { transmission: Object.keys(state.transmission) }
      : {}),
    ...(Object.keys(state.drivetrain).length ? { drivetrain: Object.keys(state.drivetrain) } : {}),
    ...(Object.keys(state.colour).length ? { colour: Object.keys(state.colour) } : {}),
    ...(Object.keys(state.membership).length ? { membership: Object.keys(state.membership) } : {}),
  }
}

export function generateElasticQuery(state) {
  return {
    filterBy: {
      multiOptions: [
        Object.keys(state.makes).length > 0 && {
          fieldName: 'make',
          values: Object.values(state.makes).map((val) => {
            return val['name'].toLowerCase()
          }),
        },
        Object.keys(state.models).length > 0 && {
          fieldName: 'model',
          values: Object.keys(state.models),
        },
        Object.keys(state.bodyStyle).length > 0 && {
          fieldName: 'bodyStyle',
          values: Object.keys(state.bodyStyle),
        },
        Object.keys(state.feature).length > 0 && {
          fieldName: 'vehicleOptions.optionName',
          values: Object.keys(state.feature),
        },
        Object.keys(state.fuel).length > 0 && {
          fieldName: 'fuelType',
          values: Object.keys(state.fuel),
        },
        Object.keys(state.engineSize).length > 0 && {
          fieldName: 'engineSize',
          // Case when Object.key is "4,5" for example (Other option in engineSize)
          values: Object.keys(state.engineSize).reduce(
            (acc, cur) => (cur.includes(',') ? acc.concat(cur.split(',')) : acc.concat(cur)),
            [],
          ),
        },
        Object.keys(state.transmission).length > 0 && {
          fieldName: 'transmissionType',
          values: Object.keys(state.transmission),
        },
        Object.keys(state.drivetrain).length > 0 && {
          fieldName: 'drivetrain',
          values: Object.keys(state.drivetrain),
        },
        Object.keys(state.colour).length > 0 && {
          fieldName: 'exteriorColour',
          values: Object.keys(state.colour),
        },
        Object.keys(state.membership).length > 0 && {
          fieldName: 'memberships.programIds',
          values: Object.keys(state.membership),
        },
        Object.keys(state.listingType).length > 0 && {
          fieldName: 'listingType',
          values: Object.keys(state.listingType).filter((i) => i !== '0'),
        },
      ].filter(Boolean),
      andRanges: [
        state.year && {
          fieldName: 'year',
          from: state.year.start,
          to: state.year.end,
        },
        state.price && {
          fieldName: 'startingPrice',
          from: state.price.start,
          to: state.price.end,
        },
        state.mileage && {
          fieldName: 'mileage',
          from: state.mileage.start,
          to: state.mileage.end,
        },
      ],
      orRanges: [
        state.leaseFinance && {
          fieldName: 'paymentDetails.leaseMonthlyPayment',
          from: state.leaseFinance.start,
          to: state.leaseFinance.end,
        },
        state.leaseFinance && {
          fieldName: 'paymentDetails.loanMonthlyPayment',
          from: state.leaseFinance.start,
          to: state.leaseFinance.end,
        }
      ]
    },
    searchTerms: [state.searchTerms && state.searchTerms].filter(Boolean),
    sortBy: {
      fieldName: state?.sortType?.fieldName || 'auctionTime',
      sortOrder: state?.sortType?.sortOrder || 'Ascending',
    },
    location:
      state.location.latitude != null && state.location.longitude != null
        ? {
            latitude: state.location.latitude,
            longitude: state.location.longitude,
          }
        : null,
    pageIndex: state.pageIndex,
    pageSize: defaultPageSize,
    distance: state.distance,
  }
}
